import {
  ParentContent,
  SubjectiveContent,
} from '@/resource/question/question.type';

const parentExample = (content: SubjectiveContent[] = []) =>
  new ParentContent(content, null);

export default parentExample;
